import React, { useState } from "react";
import {
  Home,
  Video,
  BookOpen,
  FileText,
  Upload,
  ChevronRight,
} from "lucide-react";
import styles from "./HeroSection.module.css";
import AddingHomepageHeroSection from "./Herosectionpages/AddingHomepageHeroSection";
import AddingBlogpage from "./Herosectionpages/AddingBlogpage";
import AddingVediopage from "./Herosectionpages/AddingVediopage";
import AddingHindiShortAudios from "./Herosectionpages/AddingHindiShortAudios";
import AddingEnglishShortAudios from "./Herosectionpages/AddingEnglishShortAudios";
import AddingGarhwaliShortAudios from "./Herosectionpages/AddingGarhwaliShortsAudios";
import AddingHindiReadings from "./Herosectionpages/AddingHindiReadingSectin"
import AddingEnglishReadings from "./Herosectionpages/AddingEnglishReading";
import AddingGarhwaliReadings from "./Herosectionpages/AddingGarhwaliReading";
import AddingAudioBooksSection from "./Herosectionpages/AddingAudioBooks";

function HeroSection() {
  const [activePage, setActivePage] = useState("home");

  const [isUploading, setIsUploading] = useState(false);

  // Function to render the appropriate component based on active page
  const renderComponent = () => {
    switch (activePage) {
      case "home":
        return (
          <AddingHomepageHeroSection onUpload={() => setIsUploading(true)} />
        );
      case "videos":
        return <AddingVediopage onUpload={() => setIsUploading(true)} />;
      case "blogs":
        return <AddingBlogpage onUpload={() => setIsUploading(true)} />;
      case "hindishortsaudios":
        return <AddingHindiShortAudios onUpload={() => setIsUploading(true)} />;
      case "englishshortsaudios":
        return (
          <AddingEnglishShortAudios onUpload={() => setIsUploading(true)} />
        );
      case "garhwalishortsaudios":
        return (
          <AddingGarhwaliShortAudios onUpload={() => setIsUploading(true)} />
        );
        case "audiobooks":
          return (
            <AddingAudioBooksSection onUpload={() => setIsUploading(true)} />
          );
      case "englishreading":
        return <AddingEnglishReadings onUpload={() => setIsUploading(true)} />;
      case "hindireading":
        return <AddingHindiReadings onUpload={() => setIsUploading(true)} />;
        case "garhwalireading":
          return <AddingGarhwaliReadings onUpload={() => setIsUploading(true)} />;
      default:
        return (
          <AddingHomepageHeroSection onUpload={() => setIsUploading(true)} />
        );
    }
  };

  return (
    <div className={styles.heroContainer}>
      <div className={styles.sidebar}>
        <div className={styles.logo}>
          <span>Hero Section</span>
        </div>

        <nav className={styles.navigation}>
          <button
            className={`${styles.navItem} ${
              activePage === "home" ? styles.active : ""
            }`}
            onClick={() => setActivePage("home")}
          >
            <Home size={20} />
            <span>Home Page</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>

          <button
            className={`${styles.navItem} ${
              activePage === "hindishortsaudios" ? styles.active : ""
            }`}
            onClick={() => setActivePage("hindishortsaudios")}
          >
            <FileText size={20} />
            <span>Hindi Short Audios</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>
          <button
            className={`${styles.navItem} ${
              activePage === "englishshortsaudios" ? styles.active : ""
            }`}
            onClick={() => setActivePage("englishshortsaudios")}
          >
            <FileText size={20} />
            <span>English Short Audios</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>
          <button
            className={`${styles.navItem} ${
              activePage === "garhwalishortsaudios" ? styles.active : ""
            }`}
            onClick={() => setActivePage("garhwalishortsaudios")}
          >
            <FileText size={20} />
            <span>Garhwali Short Audios</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>
          <button
            className={`${styles.navItem} ${
              activePage === "audiobooks" ? styles.active : ""
            }`}
            onClick={() => setActivePage("audiobooks")}
          >
            <FileText size={20} />
            <span>Audio Books</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>

          <button
            className={`${styles.navItem} ${
              activePage === "videos" ? styles.active : ""
            }`}
            onClick={() => setActivePage("videos")}
          >
            <Video size={20} />
            <span>Videos</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>

          <button
            className={`${styles.navItem} ${
              activePage === "blogs" ? styles.active : ""
            }`}
            onClick={() => setActivePage("blogs")}
          >
            <FileText size={20} />
            <span>Blogs</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>

          <button
            className={`${styles.navItem} ${
              activePage === "englishreading" ? styles.active : ""
            }`}
            onClick={() => setActivePage("englishreading")}
          >
            <BookOpen size={20} />
            <span>English Reading</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>

          <button
            className={`${styles.navItem} ${
              activePage === "hindireading" ? styles.active : ""
            }`}
            onClick={() => setActivePage("hindireading")}
          >
            <BookOpen size={20} />
            <span>Hindi Reading</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>
          
          <button
            className={`${styles.navItem} ${
              activePage === "garhwalireading" ? styles.active : ""
            }`}
            onClick={() => setActivePage("garhwalireading")}
          >
            <BookOpen size={20} />
            <span>Garhwali Reading</span>
            <ChevronRight size={16} className={styles.navArrow} />
          </button>
        </nav>
      </div>

      <div className={styles.mainContent}>
        <div className={styles.header}>
          <h1>
            Upload Hero Content for{" "}
            {activePage.charAt(0).toUpperCase() + activePage.slice(1)}
          </h1>
        </div>

        <div className={styles.contentArea}>
          {isUploading ? (
            <div className={styles.uploadArea}>
              <div className={styles.uploadBox}>
                <Upload size={48} />
                <h3>Upload Hero Content</h3>
                <p>Drag and drop files here or click to browse</p>
                <input
                  type="file"
                  id="fileUpload"
                  className={styles.fileInput}
                />
                <label htmlFor="fileUpload" className={styles.uploadLabel}>
                  Select Files
                </label>
                <button
                  className={styles.cancelButton}
                  onClick={() => setIsUploading(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            renderComponent()
          )}
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
